import { createTheme } from '@material-ui/core/styles';

const titles = {
  fontFamily: 'Barlow Condensed',
  fontWeight: 600,
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#3D5465',
    },
    secondary: {
      main: '#F2AA00',
    },
    tag: {
      operation: '#27AE60',
      loading: '#1DC39C',
      tipping: '#17683A',
      operationStop: '#FF9800',
      maintenance: '#D32F2F',
      empty: '#666666',
      full: '#3D3D3D',
      queue: '#995B00',
      maneuver: '#1976D2',
    },
    common: {
      white: '#FFFFFF',
      yellowGold: '#FFC300',
    },
    gray: {
      5: '#F0F0F0',
      10: '#E0E0E0',
      20: '#C2C2C2',
      30: '#A3A3A3',
      40: '#858585',
      50: '#666666',
      60: '#525252',
      70: '#474747',
      80: '#3D3D3D',
      90: '#2E2E2E',
      95: '#242424',
    },
  },
  typography: {
    useNextVariants: true,
    fontFamily: 'Roboto',
    fontWeightLight: 300,
    fontWeightRegular: 'normal',
    fontWeightMedium: 500,
    h1: {
      ...titles,
      fontWeight: 500,
    },
    h2: {
      ...titles,
    },
    h3: {
      ...titles,
    },
    h4: {
      ...titles,
    },
    h5: {
      ...titles,
    },
    h6: {
      ...titles,
    },
    button: {
      fontFamily: 'Roboto',
      fontWeight: 500,
      textTransform: 'uppercase',
    },
  },
  overrides: {
    MuiCheckbox: {
      root: {
        padding: '0px',
      },
    },
    MuiTableCell: {
      root: {
        padding: '4px',
        minHeight: '40px',
        height: '40px',
      },
    },
    MuiIconButton: {
      root: {
        padding: 0,
      },
    },
    MuiInputAdornment: {
      root: {
        marginRight: 0,
      },
    },
  },
});

export default theme;
